"use client";

import { themeColors } from "@/utils/themeColors";
import { UserDetails } from "@knowt/syncing/graphql/schema";
import UserProfileInviteLink from "./UserProfileInviteLink";
import dynamic from "next/dynamic";
import { useState } from "react";
import br from "@/styles/breakpoints.module.css";
import LazyLoaded from "@/components/LazyLoaded";
import clsx from "clsx";
import { spacing } from "@/utils/spacing";
import { FlexColumn } from "@/components/Flex";

const UserReferralCodePopup = dynamic(() => import("@/components/userListCard/popups/UserReferralCodePopup"));

const ProfilePageInviteLink = ({ user }: { user: UserDetails | null | undefined }) => {
    const [isQRPopupOpen, setIsQRPopupOpen] = useState(false);

    return (
        <FlexColumn>
            <UserProfileInviteLink
                id="profile-screen-referral-section"
                className={clsx(br.smDownColumn, br.mdDownRow)}
                isOwner
                referral={user?.ref_v2}
                refList={user?.refList_v2 || []}
                onQRPopupOpen={() => setIsQRPopupOpen(true)}
                style={{
                    backgroundColor: themeColors.neutralWhite,
                    padding: `${spacing.MD_S} ${spacing.MD_S}`,
                    borderRadius: `${spacing.MD_S}`,
                }}
            />

            <LazyLoaded load={isQRPopupOpen}>
                <UserReferralCodePopup
                    isOpen={isQRPopupOpen}
                    onClose={() => {
                        setIsQRPopupOpen(false);
                    }}
                    referralCode={user?.ref_v2 || ""}
                />
            </LazyLoaded>
        </FlexColumn>
    );
};

export default ProfilePageInviteLink;
